import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment-timezone';
import HourRow from './HourRow';
import { colors } from '../../../../../constants/colors';
import { genHours } from './util/hours';
import { fontSize, fontFamily } from '../../../../../constants/text';
import SpecialHoursRow from './SpecialHourRow';

const Root = styled.div`
  max-width: 335px;
`;

const Title = styled.h2`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.default};
  color: ${colors.squid};
`;

const List = styled.ol`
  list-style: none;
  padding: 0;
`;

const getWeeklyHours = (hours, hoursDefault, specialOperatingHours, currentDay, timeZone) => {
  const reorderedHoursForDays = genHours(hours, hoursDefault, specialOperatingHours, timeZone);
  // Reordering the days of the week so we start displaying the days from "today" day of the week instead of always starting with Monday
  const currentDayIndex = reorderedHoursForDays.findIndex(el => el.day === currentDay);
  for (let i = 0; i < currentDayIndex; ++i) {
    reorderedHoursForDays.push(reorderedHoursForDays.shift());
  }
  return reorderedHoursForDays;
};

const BusinessHours = props => {
  const {
    location: { hours, timeZone, hoursDefault, specialOperatingHours },
    className,
  } = props;
  const currentDay = timeZone
    ? moment()
        .tz(timeZone)
        .format('dddd')
    : moment().format('dddd');

  const { current: weeklyHours } = useRef(
    getWeeklyHours(hours, hoursDefault, specialOperatingHours, currentDay, timeZone)
  );

  return (
    <Root className={className}>
      <Title>BUSINESS HOURS</Title>
      <List>
        {weeklyHours.map((mappedHours, i) =>
          mappedHours.isSpecialHour ? (
            <SpecialHoursRow
              key={i}
              highlighted={currentDay === mappedHours.day}
              {...mappedHours}
            />
          ) : (
            <HourRow key={i} highlighted={currentDay === mappedHours.day} {...mappedHours} />
          )
        )}
      </List>
    </Root>
  );
};

BusinessHours.propTypes = {
  location: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default BusinessHours;
